import React, {useEffect} from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box'
import DefaultMainPanel from "./default-main-panel";
import RouteSearchTab from "./route-serch-tab";
import StationsSearchTab from "./stations-serch-tab";


import {setViewedStop,setViewedTrip,setViewedRoute, setMainPanelContent} from '../../actions/ui'
import {setUrlSearch} from "../../actions/api";
import {setUrlQueryParam} from "../../actions/form";
import {makeStyles} from 'tss-react/mui';

import {Link, useLocation} from "react-router-dom";
import { useQueryParams } from '../../hooks/useQueryParams';

import i18n from "../../../i18nSetup";

const useStyles = makeStyles()((theme) => ({
    tab: {
        width: 120,
        minWidth: 120,
        textTransform: 'uppercase'
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    const { hasParam } = useQueryParams();
    const isHeadless = hasParam('headless');

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index &&
            (
               <Box mt={isHeadless ? 1 : 3}>{children}</Box>
            )
            }
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function MainPanelTabs(props) {
    let location = useLocation();
    const [tabValue, setTabValue] = React.useState(0);
    const {classes} = useStyles();
    const { navigateWithParams } = useQueryParams();

    const setTab = (pathname) => {
        if (pathname.includes('/route/')) {
            setTabValue(1)
        } else if (pathname.includes('/stop/')) {
            setTabValue(2)
        } else {
            switch (pathname) {
                case '/searchRoute':
                case '/route':
                    setTabValue(1);
                    break;
                case '/searchStations':
                case '/stop':
                    setTabValue(2);
                    break;
                default:
                    setTabValue(0);
            }
        }
    };

    useEffect(() => {
        setTab(location.pathname)
    }, [location.pathname]);


    const handleChange = (event, newValue) => {
        setTabValue(newValue);
        initTripScreen();
        
        // Navigate to the appropriate route while preserving query parameters
        switch (newValue) {
            case 0:
                navigateWithParams('/plan');
                break;
            case 1:
                navigateWithParams('/searchRoute');
                break;
            case 2:
                navigateWithParams('/searchStations');
                break;
            default:
                navigateWithParams('/plan');
        }
    };
    
    const initTripScreen = () => {
        props.setViewedStop(null)
        props.setViewedTrip(null)
        props.setMainPanelContent(null)
    }
    useEffect(() => {
            props.setUrlQueryParam();
            props.setUrlSearch();
        return () => {
                //props.setUrlSearch();
        }
    }, [tabValue]);
    
    return(
        <div id={'panelTabs'}>
                <Tabs
                    value={tabValue}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={handleChange}
                >
                    <Tab className={classes.tab} label={i18n.t('directions')} />
                    <Tab className={classes.tab} label={i18n.t('routes')} />
                    <Tab className={classes.tab} label={i18n.t('stations')} />
                </Tabs>
            <TabPanel value={tabValue} index={0}>
                <DefaultMainPanel/>
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
                <RouteSearchTab/>
            </TabPanel>
            <TabPanel value={tabValue} index={2}>
                <StationsSearchTab/>
            </TabPanel>
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
    return {
            ...state
    }
}
const mapDispatchToProps = (dispatch, ownProps) => {

    return {
        setViewedStop:(obj) => {dispatch(setViewedStop(obj))},
        setViewedTrip:(obj) => {dispatch(setViewedTrip(obj))},
        setViewedRoute:(obj) => {dispatch(setViewedRoute(obj))},
        setMainPanelContent:(obj) => {dispatch(setMainPanelContent(obj))},
        setUrlSearch:(obj, obj2) => {dispatch(setUrlSearch(obj))},
        setUrlQueryParam:() => {dispatch(setUrlQueryParam())}
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(MainPanelTabs)